// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1kzeY","tab":"ProcedureTabs_tab__S7B7Z"};